export const isOldPricingSelector = (state: RootState) =>
  !state.account.accountState.data?.is_support_shard_type;

export const oldPricingPriceDetailsSelector = (state: RootState) =>
  state.databases?.oldPricingPriceDetails;
